export default "__VITE_ASSET__ec413462__"